import Vue from 'vue';

// main.js includes global styles, polyfills, shared scripts, i18n, and
// component initialization
import '@/base/global-js/main.js';

import '@/base/global-js/LazyTrigger.js';

// Component dependencies
import MyTripReportsApp from './MyTripReportsApp.vue';
Vue.component('MyTripReportsApp', MyTripReportsApp);

import TripReportApp from './TripReportApp.vue';
Vue.component('TripReportApp', TripReportApp);

import EditTripReportApp from './EditTripReportApp.vue';
Vue.component('EditTripReportApp', EditTripReportApp);

// base
import CloBadge from '@/base/CloBadge/CloBadge';
Vue.component('CloBadge', CloBadge);

import CloButton from '@/base/CloButton/CloButton';
Vue.component('CloButton', CloButton);

import CloDialog from '@/base/CloDialog/CloDialog';
Vue.component('CloDialog', CloDialog);

import CloDivider from '@/base/CloDivider/CloDivider';
Vue.component('CloDivider', CloDivider);

import CloDropdown from '@/base/CloDropdown/CloDropdown';
Vue.component('CloDropdown', CloDropdown);

import CloHeading from '@/base/CloHeading/CloHeading';
Vue.component('CloHeading', CloHeading);

import CloPage from '@/base/CloPage/CloPage';
Vue.component('CloPage', CloPage);

import CloUnorderedList from '@/base/CloUnorderedList/CloUnorderedList';
Vue.component('CloUnorderedList', CloUnorderedList);

// grid
import CloGridFlex from '@/grid/CloGridFlex/CloGridFlex';
Vue.component('CloGridFlex', CloGridFlex);

// icons
import CloIcon from '@/icons/CloIcon/CloIcon';
Vue.component('CloIcon', CloIcon);

// logos
import CloLogoEbird from '@/logos/CloLogoEbird/CloLogoEbird';
Vue.component('CloLogoEbird', CloLogoEbird);

import CloLogoLab from '@/logos/CloLogoLab/CloLogoLab';
Vue.component('CloLogoLab', CloLogoLab);

import CloLogoLabSapsucker from '@/logos/CloLogoLabSapsucker/CloLogoLabSapsucker';
Vue.component('CloLogoLabSapsucker', CloLogoLabSapsucker);

import CloLogoLabShort from '@/logos/CloLogoLabShort/CloLogoLabShort';
Vue.component('CloLogoLabShort', CloLogoLabShort);

// navigation
import CloHeader from '@/navigation/CloHeader/CloHeader.vue';
Vue.component('CloHeader', CloHeader);

import CloFooter from '@/navigation/CloFooter/CloFooter.vue';
Vue.component('CloFooter', CloFooter);

// component initialization, dialogs, exotic dialog, lazy loading components
import '../shared/sharedLichen.js';